module.exports = __webpack_public_path__ + "img/chat_icon.78883ba8.svg";